export default "__VITE_ASSET__DZIqLn8s__"